import { render, staticRenderFns } from "./ProbationaryAgentEdit.vue?vue&type=template&id=5efd6685&scoped=true&"
import script from "./ProbationaryAgentEdit.vue?vue&type=script&lang=js&"
export * from "./ProbationaryAgentEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProbationaryAgentEdit.vue?vue&type=style&index=0&id=5efd6685&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd6685",
  null
  
)

export default component.exports